<!--
    אפליקציה במסך הבית - the settings-page section (הגדרות → כללי) for adding PlanUp to the home
    screen of the device the settings are open on. Everything here is about THIS device and is kept
    in its own storage (modules/HomeScreenInstall.js) - nothing goes through the tab's שמור.

    - opened from the icon right now → says so
    - otherwise the button: the browser's own install dialog when it offers one (Chrome / Edge /
      Samsung), else the popup with the steps for this device (HomeScreenPrompt, $root event)
    - phones / tablets: the checkbox for the popup after login (off = what "לא להציג שוב" did)
-->
<template>
    <div class="homeScreenSettings">

        <div class="homeScreenSettingsIntro">
            <img class="homeScreenSettingsIcon"
                 src="/static/pwa/apple-touch-icon.png"
                 alt="">
            <div>
                PlanUp יכולה לשבת במסך הבית של הטלפון או הטאבלט, כמו אפליקציה: נפתחת בלחיצה אחת,
                במסך מלא ובלי שורת הכתובת של הדפדפן.
            </div>
        </div>

        <div v-if="state.standalone"
             class="homeScreenSettingsState">
            <i class="fa-solid fa-circle-check"></i>
            PlanUp פתוחה עכשיו מתוך מסך הבית של המכשיר הזה.
        </div>

        <div v-else
             class="homeScreenSettingsRow">

            <span v-if="installedHere"
                  class="homeScreenSettingsState">
                <i class="fa-solid fa-circle-check"></i>
                נוספה למסך הבית במכשיר הזה.
            </span>

            <button type="button"
                    class="btn homeScreenSettingsAdd"
                    :class="installedHere ? 'btn-light btn-sm' : 'btn-primary'"
                    :disabled="installing"
                    @click="add">
                <i :class="installing ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-mobile-screen-button'"></i>
                {{ buttonLabel }}
            </button>

        </div>

        <label v-if="showOfferToggle"
               class="homeScreenSettingsOffer"
               @click.prevent="toggleOffer">
            <span style="position:relative;top:1px;"
                  class="planup-checkbox planup-checkbox-purple"
                  :class="{ checked: offerOn }">
                <i class="fa fa-check"></i>
            </span>
            להציע את זה בחלון קטן אחרי הכניסה למערכת (במכשיר הזה)
        </label>

        <div v-else-if="platform == 'desktop' && !state.standalone"
             class="homeScreenSettingsNote">
            בטלפון ובטאבלט מוצע גם חלון קטן אחרי הכניסה למערכת.
        </div>

    </div>
</template>

<script>

import { homeScreenState, devicePlatform, isInstalled, offerAfterLoginIsOn, setOfferAfterLogin, promptInstall } from '@/modules/HomeScreenInstall';

export default {

    name: 'HomeScreenSettings',

    data() {
        return {
            state: homeScreenState,
            platform: devicePlatform(),
            installing: false,
        }
    },

    computed: {

        //homeScreenState is reactive: these follow "הוספתי" / the browser's appinstalled at once
        installedHere() {
            return isInstalled();
        },

        offerOn() {
            return offerAfterLoginIsOn();
        },

        showOfferToggle() {
            return this.platform != 'desktop' && !this.installedHere;
        },

        buttonLabel() {

            if (this.installedHere)
                return 'הוספה שוב';

            if (this.platform == 'desktop' && this.state.canPrompt)
                return 'התקנה במחשב';

            return 'הוספה למסך הבית';

        },

    },

    methods: {

        //straight from the click: the browser's dialog needs the user's gesture
        add() {

            if (!this.state.canPrompt) {
                this.$root.$emit('openHomeScreenPrompt', 'steps');
                return;
            }

            this.installing = true;

            promptInstall().then(outcome => {

                this.installing = false;

                if (outcome == 'accepted')
                    this.$notify({ type: 'success', title: 'PlanUp נוספה למסך הבית', duration: 3000 });
                else if (outcome == 'unavailable')
                    this.$root.$emit('openHomeScreenPrompt', 'steps');

            });

        },

        toggleOffer() {
            setOfferAfterLogin(!this.offerOn);
        },

    },

}

</script>

<style>
.homeScreenSettings .homeScreenSettingsIntro {
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: 640px;
    color: #777;
    margin-bottom: 12px;
}

.homeScreenSettings .homeScreenSettingsIcon {
    flex: 0 0 auto;
    width: 44px;
    height: 44px;
    border-radius: 11px;
    border: 1px solid #ece8f5;
}

.homeScreenSettings .homeScreenSettingsRow {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 10px;
}

.homeScreenSettings .homeScreenSettingsState {
    color: #2e9e6b;
    font-weight: 600;
}

.homeScreenSettings .homeScreenSettingsState i {
    margin-left: 4px;
}

.homeScreenSettings .homeScreenSettingsAdd i {
    margin-left: 4px;
}

.homeScreenSettings .homeScreenSettingsOffer {
    user-select: none;
    cursor: pointer;
    margin-top: 2px;
}

.homeScreenSettings .homeScreenSettingsNote {
    font-size: 13px;
    color: #999;
}
</style>
